export default __webpack_public_path__ + "static/media/profile-pic.14953df5.webp";